export default __webpack_public_path__ + "static/media/f_row.724e2fa4.svg";